module.exports = __webpack_public_path__ + "media/images/lb/870-52857aaf8120a8d98ac45b563c1ed2d8.svg";